var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-set-express",
      attrs: {
        title: "请选择指定快递",
        visible: _vm.visibleDialog,
        width: "270px",
        top: "calc(50vh - 280px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "radio-group",
          model: {
            value: _vm.radio,
            callback: function ($$v) {
              _vm.radio = $$v
            },
            expression: "radio",
          },
        },
        _vm._l(_vm.expressList, function (item) {
          return _c(
            "el-radio",
            { key: item.dictId, attrs: { label: item.dictId } },
            [_vm._v(_vm._s(item.dictName))]
          )
        }),
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }